<div class="edit_profile">
  <slotcom-h2 [text]="'home.profile.changePassword' | translate"></slotcom-h2>
  <slotcom-navigation-button
    type="close"
    width="3"
    height="3"
    topPosition="-1"
    rightPosition="-1"
    (click)="close()">
  </slotcom-navigation-button>
</div>
<hr class="c-divider" />
<form>
  <div class="c-field">
    <input
      type="text"
      name="username"
      autocomplete="username"
      style="display: none" />
    <input
      class="c-field__input"
      id="current"
      autocomplete="current-password"
      [type]="hideCurrent() ? 'password' : 'text'"
      [formControl]="current"
      maxlength="100" />
    @if (!current.value) {
      <label class="c-field__label">{{ 'home.profile.currentPassword' | translate }}</label>
    }
    <button
      type="button"
      class="c-field__suffix"
      tabindex="-1"
      (click)="hideCurrent.set(!hideCurrent())">
      <span
        tabindex="-1"
        class="icons-sprite tiny"
        [ngClass]="hideCurrent() ? 'no-visible' : 'visible'"></span>
    </button>
    <div class="c-field__line"></div>
    <div class="c-field__subscript">
      @if (current.invalid && current.touched && current.errors.required) {
        <span class="c-field__error">{{ 'home.profile.fieldRequired' | translate }}</span>
      } @else if (current.invalid && current.touched && current.errors.minlength) {
        <span class="c-field__error">{{ 'home.profile.minLength' | translate }}</span>
      } @else if (current.invalid && current.touched && current.errors.invalidPassword) {
        <span class="c-field__error">{{ 'home.profile.invalidPassword' | translate }}</span>
      }
    </div>
  </div>

  <div class="c-field">
    <input
      class="c-field__input"
      id="new"
      autocomplete="new-password"
      [type]="hideNew() ? 'password' : 'text'"
      [formControl]="new"
      maxlength="100" />
    @if (!new.value) {
      <label class="c-field__label">{{ 'home.profile.newPassword' | translate }}</label>
    }
    <button
      type="button"
      class="c-field__suffix"
      tabindex="-1"
      (click)="hideNew.set(!hideNew())">
      <span
        tabindex="-1"
        class="icons-sprite tiny"
        [ngClass]="hideNew() ? 'no-visible' : 'visible'"></span>
    </button>
    <div class="c-field__line"></div>
    <div class="c-field__subscript">
      @if (new.invalid && new.touched && new.errors.required) {
        <span class="c-field__error">{{ 'home.profile.fieldRequired' | translate }}</span>
      } @else if (new.invalid && new.touched && new.errors.minlength) {
        <span class="c-field__error">{{ 'home.profile.minLength' | translate }}</span>
      }
    </div>
  </div>

  <slotcom-button
    [isDisabled]="current.invalid || new.invalid"
    (safeClick)="onSubmit()"
    audioType="functionality"
    class="c-button--pink small">
    {{ 'common.saveChanges' | translate }}
  </slotcom-button>
</form>
